export default __webpack_public_path__ + "static/media/CLICHY (88 sur 176).c26d6ae5.jpg";